import Link from "next/link";

export default function ElementsSection({
  title,
  children,
  more = undefined,
  className,
}) {
  return (
    <div className={`my-8 ${className || ""}`}>
      {/* ENCABEZADO REDISEÑADO CON BARRA AMARILLA */}
      <div className="flex items-center gap-3 mb-5 select-none">
        {/* Pequeña barra vertical institucional */}
        <div className="w-1.5 h-6 bg-yellow-500 rounded-sm shadow-sm"></div>
        
        <h2 className="text-xl md:text-2xl font-black uppercase tracking-tight text-gray-900 italic">
          {title}
        </h2>
      </div>

      {/* CONTENIDO (EL GRID DE LAS TARJETAS DE CARROS) */}
      {children}

      {/* BOTÓN DE "VER MÁS" INFERIOR */}
      {more && (
        <div className="flex pt-6 justify-center">
          <Link href={more.url}>
            <a>
              <button className="px-12 text-zinc-700 hover:text-black hover:bg-yellow-500/10 font-bold uppercase tracking-wider text-xs py-3 rounded-md border border-zinc-300 hover:border-yellow-500 transition-all duration-300">
                {more.text ? more.text : more}
              </button>
            </a>
          </Link>
        </div>
      )}
    </div>
  );
}